import { Observable } from 'rxjs';
import { BaseInput, BaseInputConstructor } from './base-input';

export interface ListInputConstructor extends BaseInputConstructor {
  options: Observable<string[]>;
  class?: string[];
}

export class ListInput extends BaseInput {
  inputType = 'list';
  options: Observable<string[]>;
  class?: string[];

  constructor(options: ListInputConstructor) {
    super(options);
    this.options = options.options;
    this.class = options.class || [];
  }
}
